import React, { useState, useEffect } from "react";
import { View, Text, Image, TextInput, TouchableOpacity, Dimensions } from "react-native";
import { useNavigate } from "react-router-dom";
import styles from "../styles/pages/registotpStyles";
import { showError } from "src/utils/sweetAlert";

const RegistOTP: React.FC = () => {
  const [password, setPassword] = useState<string>("");
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [qrImage, setQrImage] = useState<any>(null);
  const [showManualKey, setShowManualKey] = useState(false);
  const navigate = useNavigate();
  const isMobile = Dimensions.get('window').width < 768;

  const CORRECT_PASSWORD = "dainls123!@#";

  const handlePasswordSubmit = () => {
    if (password === CORRECT_PASSWORD) {
      setQrImage(require("../assets/admin-qr-code.png"));
      setIsAuthenticated(true);
      setError(null);
    } else {
      showError("잘못된 비밀번호입니다.");
      setIsAuthenticated(false);
      setQrImage(null);
    }
  };

  // 조건부 스타일 적용
  const containerStyle = isMobile ? [styles.container, styles.mobileContainer] : styles.container;
  const titleStyle = isMobile ? [styles.title, styles.mobileTitle] : styles.title;
  const inputStyle = isMobile ? [styles.input, styles.mobileInput] : styles.input;
  const buttonStyle = isMobile ? [styles.button, styles.mobileButton] : styles.button;
  const buttonTextStyle = isMobile ? [styles.buttonText, styles.mobileButtonText] : styles.buttonText;
  const qrContainerStyle = isMobile ? [styles.qrContainer, styles.mobileQrContainer] : styles.qrContainer;
  const instructionsContainerStyle = isMobile ? [styles.instructionsContainer, styles.mobileInstructionsContainer] : styles.instructionsContainer;

  if (!isAuthenticated) {
    return (
      <View style={containerStyle}>
        <Text style={titleStyle}>Google OTP 등록</Text>
        <TextInput
          style={inputStyle}
          value={password}
          onChangeText={setPassword}
          secureTextEntry
          placeholder="비밀번호 입력"
          onSubmitEditing={handlePasswordSubmit}
          returnKeyType="done"
        />
        {error && <Text style={styles.errorText}>{error}</Text>}
        <TouchableOpacity style={buttonStyle} onPress={handlePasswordSubmit}>
          <Text style={buttonTextStyle}>확인</Text>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={containerStyle}>
      <Text style={titleStyle}>Google OTP 등록</Text>
      {qrImage && (
        <View style={qrContainerStyle}>
          <Image source={qrImage} style={isMobile ? styles.mobileQrCode : styles.qrCode} resizeMode="contain" />
        </View>
      )}
      <View style={instructionsContainerStyle}>
        <Text style={isMobile ? styles.mobileInstructionsTitle : styles.instructionsTitle}>등록 방법</Text>
        <Text style={isMobile ? styles.mobileInstructionText : styles.instructionText}>
          1. Google Authenticator 앱을 설치하세요
        </Text>
        <Text style={isMobile ? styles.mobileInstructionText : styles.instructionText}>2. QR 코드를 스캔하세요</Text>
        <Text style={isMobile ? styles.mobileInstructionText : styles.instructionText}>
          3. 생성된 6자리 코드를 홈 화면에서 입력하세요
        </Text>
        <TouchableOpacity onPress={() => setShowManualKey(!showManualKey)}>
          <Text style={[isMobile ? styles.mobileInstructionText : styles.instructionText, { textDecorationLine: 'underline' }]}>
            상단 QR 코드로 OTP 등록이 되지 않으신다면 눌러 주세요
          </Text>
        </TouchableOpacity>
        {showManualKey && (
          <View style={{ marginTop: 10 }}>
            <Text style={isMobile ? styles.mobileInstructionText : styles.instructionText}>수동 입력 정보:</Text>
            <Text style={isMobile ? styles.mobileInstructionText : styles.instructionText}>• 계정 이름: PMSAdmin</Text>
            <Text style={isMobile ? styles.mobileInstructionText : styles.instructionText}>
              • 키 값: JBSWY3DPEHPK3PXP7QYTCXLY
            </Text>
          </View>
        )}
      </View>
      <TouchableOpacity
        style={isMobile ? [styles.button, styles.completeButton, styles.mobileButton] : [styles.button, styles.completeButton]}
        onPress={() => navigate("/")}
      >
        <Text style={buttonTextStyle}>홈 화면으로</Text>
      </TouchableOpacity>
    </View>
  );
};

export default RegistOTP;